import gql from 'graphql-tag';

export const CMS_QUERY_MANUAL_BOOKINGS = gql`
  query CMS_QueryLandlordBookings(
    $slug: String
    $bookingJourneys: [BookingJourney!]!
    $states: [BookingState!]!
    $pageSize: PositiveInteger = 10
    $pageNumber: PositiveInteger = 1
    $sortDirection: SortDirection = DESCENDING
    $stages: JSON
  ) {
    landlord(slug: $slug) {
      unionBookings(
        bookingJourneys: $bookingJourneys
        states: $states
        sortDirection: $sortDirection
        pageSize: $pageSize
        pageNumber: $pageNumber
        stages: $stages
      ) {
        edges {
          node {
            id
            bookingJourney
            referenceId
            currency
            moveInDate
            moveOutDate
            landlord {
              name
              id
            }
            student {
              firstName
              lastName
              passportFirstName
              passportLastName
            }
            stage
            createdAt
          }
        }
        totalCount
        pageInfo {
          hasNextPage
          numPages
        }
      }
    }
  }
`;

export const CMS_QUERY_BOOK_BOOKINGS = gql`
  query CMS_QueryOrderList(
    $bookingJourneys: [ListingPlan]!
    $id: ID
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $propertyName: NonEmptyString
    $referenceId: NonEmptyString
    $sortBy: SortBy
    $sortDirection: SortDirection
    $stages: [OrderStage]
    $studentName: NonEmptyString
    $passportFullName: NonEmptyString
    $commissionTriggerPoint: CommissionTriggerPointType
  ) {
    listOrders(
      bookingJourneys: $bookingJourneys
      id: $id
      pageNumber: $pageNumber
      pageSize: $pageSize
      propertyName: $propertyName
      referenceId: $referenceId
      sortBy: $sortBy
      sortDirection: $sortDirection
      stages: $stages
      studentName: $studentName
      passportFullName: $passportFullName
      commissionTriggerPoint: $commissionTriggerPoint
    ) {
      edges {
        node {
          id
          stage
          passportFullName
          student {
            fullName
          }
          landlord {
            name
          }
          property {
            name
          }
          moveInDate
          moveOutDate
          tenancyLength {
            weeks
            days
          }
          commissions {
            currency
            totalPrice
          }
          commissionTriggerPoint
          canUpdateListOrderStage
          createdAt
          bookingJourney
          referenceId
          unitTypeId
          unitTypeName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const CMS_QUERY_BOOKINGS_COUNT = gql`
  query CMS_QueryBookingsCount($slug: String) {
    landlord(slug: $slug) {
      manualCount: unionBookings(
        bookingJourneys: [MANUAL]
        states: [IN_PROGRESS, COMPLETED, LOST]
      ) {
        totalCount
      }
      messagePropertyCount: unionBookings(
        bookingJourneys: [SEMI_AUTOMATIC]
        states: [IN_PROGRESS, COMPLETED, LOST]
      ) {
        totalCount
      }
    }
  }
`;
